<template>
    <ContainerLayout page="0">
        <template v-slot:navbar>
            <nav class="navbar navbar-expand navbar-light bg-white text-dark">
                <router-link to="/profile" class="nav-link">
                    <font-awesome-icon icon="arrow-left" class="text-dark" />
                </router-link>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 class="nav-link mb-0 text-dark font-weight-bold">
                            {{ $route.meta.title }}
                        </h6>
                    </li>
                </div>
                <!-- <div class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <router-link to="/register" class="nav-link">
                            <font-awesome-icon icon="pencil" class="text-secondary" />
                        </router-link>
                    </li>
                </div> -->
            </nav>
            <hr class="my-0" style="height: 1.5px;">
        </template>
        <div class="content" v-if="currentCompany">
            <div class="d-flex flex-column">
                <div class="mb-0">
                    <div class="mb-3">
                        <div class="d-flex justify-content-center align-items-center">
                            <img id="profile-img" class="profile-img-full"
                                :src="currentCompany.image_url ?? '//ssl.gstatic.com/accounts/ui/avatar_2x.png'" />
                        </div>
                    </div>
                    <div class="mb-1">
                        <div class="d-flex justify-content-center align-items-center">
                            <h5 class="font-weight-bold mb-0">{{ currentCompany.name }}</h5>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex justify-content-center align-items-center">
                            <span>{{ currentCompany.company_type.current_name }}</span>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex justify-content-center align-items-center">
                            <span v-if="currentCompany.is_pkp" class="badge badge-pill badge-main my-2 mx-1">PKP</span>
                            <span v-else class="badge badge-pill badge-secondary my-2 mr-1">Non-PKP</span>
                            <span v-if="currentCompany.verified_at" class="badge badge-pill badge-main my-2">Verified</span>
                            <span v-else class="badge badge-pill badge-secondary my-2">Not Verified Yet</span>
                        </div>
                    </div>
                </div>
                <div class="card mt-4 mb-2"
                    style="border-radius: 0.25rem; border: 1.5px solid rgba(0,0,0,.125); box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2); display: flex; flex-direction: column; justify-content: space-between;">
                    <div v-if="selected_branch" class="py-2 px-3 d-flex justify-content-between align-items-center">
                        <small>
                            {{ branches.length }} {{ branches.length > 1 ? $t('Branches') : $t('Branch') }}
                        </small>
                        <div @click.prevent="changeBranch()" class="btn btn-sm btn-outline-main ml-2"
                            style="min-width: 83px; cursor: pointer;">
                            <span>
                                <span v-if="screen() == 'sm' && selected_branch.name.length > 25">
                                    {{ selected_branch.name.substring(0, 25) + '...' }}
                                </span>
                                <span v-else>
                                    {{ selected_branch.name }}
                                </span>
                                <font-awesome-icon v-if="modal_branch_opened == false" icon="chevron-down" class="ml-2" />
                                <font-awesome-icon v-else icon="chevron-up" class="ml-2" />
                            </span>
                        </div>
                    </div>
                    <div v-else class="py-2 px-3 d-flex justify-content-between align-items-center">
                        <small>
                            {{ $t('No Branches Yet') }}
                        </small>
                        <div @click.prevent="addBranch()" class="btn btn-sm btn-outline-main ml-2"
                            style="min-width: 83px; cursor: pointer;">
                            <span>
                                <span>
                                    {{ $t('Add Branch') }}
                                </span>
                                <font-awesome-icon icon="plus" class="ml-2" />
                            </span>
                        </div>
                    </div>
                </div>
                <div class="card mt-2 mb-2"
                    style="border-radius: 0.25rem; border: 1.5px solid rgba(0,0,0,.125); box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2); display: flex; flex-direction: column; justify-content: space-between;">
                    <div class="py-2 px-3 d-flex justify-content-between align-items-center">
                        <small v-if="!loading">
                            {{ users.length }} {{ users.length > 1 ? $t('Accounts') : $t('Account') }}
                        </small>
                        <div v-else class="skeleton-line"></div>
                        <router-link to="/profile/company/user" class="btn btn-sm btn-outline-main ml-2"
                            style="min-width: 83px; cursor: pointer;">
                            <span>
                                <span>
                                    {{ $t('View Details') }}
                                </span>
                                <font-awesome-icon icon="chevron-right" class="ml-2" />
                            </span>
                        </router-link>
                    </div>
                </div>
                <div class="card mt-2 mb-4"
                    style="border-radius: 0.25rem; border: 1.5px solid rgba(0,0,0,.125); box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2); display: flex; flex-direction: column; justify-content: space-between;">
                    <div class="py-2 px-3 d-flex justify-content-between align-items-center">
                        <small v-if="!loading">
                            {{ transactions.length }} {{ transactions.length > 1 ?
                                $t('Purchases') : $t('Purchase') }}
                        </small>
                        <div v-else class="skeleton-line"></div>
                        <router-link to="/profile/company/transaction" class="btn btn-sm btn-outline-main ml-2"
                            style="min-width: 83px; cursor: pointer;">
                            <span>
                                <span>
                                    {{ $t('View Details') }}
                                </span>
                                <font-awesome-icon icon="chevron-right" class="ml-2" />
                            </span>
                        </router-link>
                    </div>
                </div>
                <div v-if="!currentCompany.verified_at">
                    <div class="mb-3">
                        <div class="d-flex flex-column">
                            <div class="d-flex flex-row align-items-center">
                                <span style="font-weight: 600;">{{ $t('Verification Status') }}</span>
                            </div>
                            <div class="d-flex flex-row align-items-center mt-2">
                                <small v-if="currentCompany.verified_at">Verified</small>
                                <small v-else>
                                    {{ $t('Verification is still in process.') }}
                                    {{ $t('Please complete the information from Verification Notes if any.') }}
                                </small>
                            </div>
                        </div>
                        <hr class="mt-1">
                    </div>
                    <div class="mb-3">
                        <div class="d-flex flex-column">
                            <div class="d-flex flex-row align-items-center">
                                <span style="font-weight: 600;">{{ $t('Verification Notes') }}</span>
                            </div>
                            <div class="d-flex flex-row align-items-center mt-2">
                                <small>{{ currentCompany.verification_note ?? '-' }}</small>
                            </div>
                        </div>
                        <hr class="mt-1">
                    </div>
                </div>
                <div class="mb-3">
                    <div class="d-flex flex-column">
                        <div class="d-flex flex-row align-items-center">
                            <span style="font-weight: 600;">{{ $t('Customer ID') }}</span>
                        </div>
                        <div class="d-flex flex-row align-items-center mt-2">
                            <small>{{ currentCompany.customer_id ?? '-' }}</small>
                        </div>
                    </div>
                    <hr class="mt-1">
                </div>
                <div class="mb-3">
                    <div class="d-flex flex-column">
                        <div class="d-flex flex-row align-items-center">
                            <span style="font-weight: 600;">{{ $t('NPWP Number') }}</span>
                        </div>
                        <div class="d-flex flex-row align-items-center mt-2">
                            <small>{{ currentCompany.npwp_number ?? '-' }}</small>
                        </div>
                    </div>
                    <hr class="mt-1">
                </div>
                <div class="mb-3">
                    <div class="d-flex flex-column">
                        <div class="d-flex flex-row align-items-center">
                            <span style="font-weight: 600;">{{ $t('NPWP') }}</span>
                        </div>
                        <div class="d-flex flex-row align-items-center mt-2">
                            <button v-if="currentCompany.npwp_file" class="btn btn-sm btn-main"
                                @click.prevent="openIframe(currentCompany.npwp_url, '{{ currentCompany.customer_id }}_NPWP')">
                                <small>{{ $t('Preview') }}</small>
                            </button>
                            <small v-else>-</small>
                        </div>
                    </div>
                    <hr class="mt-1">
                </div>
                <div v-if="currentCompany.is_pkp">
                    <div class="mb-3">
                        <div class="d-flex flex-column">
                            <div class="d-flex flex-row align-items-center">
                                <span style="font-weight: 600;">{{ $t('SPPKP') }}</span>
                            </div>
                            <div class="d-flex flex-row align-items-center mt-2">
                                <button v-if="currentCompany.sppkp_file" class="btn btn-sm btn-main"
                                    @click.prevent="openIframe(currentCompany.sppkp_url, '{{ currentCompany.customer_id }}_SPPKP')">
                                    <small>{{ $t('Preview') }}</small>
                                </button>
                                <small v-else>-</small>
                            </div>
                        </div>
                        <hr class="mt-1">
                    </div>
                    <div class="mb-3">
                        <div class="d-flex flex-column">
                            <div class="d-flex flex-row align-items-center">
                                <span style="font-weight: 600;">{{ $t('SKT') }}</span>
                            </div>
                            <div class="d-flex flex-row align-items-center mt-2">
                                <button v-if="currentCompany.skt_file" class="btn btn-sm btn-main"
                                    @click.prevent="openIframe(currentCompany.skt_url, '{{ currentCompany.customer_id }}_SKT')">
                                    <small>{{ $t('Preview') }}</small>
                                </button>
                                <small v-else>-</small>
                            </div>
                        </div>
                        <hr class="mt-1">
                    </div>
                </div>
            </div>
        </div>
        <vue-bottom-sheet ref="modalBranch" :swipeable="false" :rounded="true" max-height="80vh"
            @opened="modal_branch_opened = true" @closed="modal_branch_opened = false">
            <div id="modal-main-branch" style="height: 80vh; max-height: 80vh;">
                <div v-if="branches">
                    <div id="modal-body-branch">
                        <div style="overflow-y: auto; height: 100%;">
                            <div v-for="(branch, index) in branches" :key="index"
                                class="d-flex flex-row justify-content-between align-items-center mb-2"
                                style="cursor: pointer;" @click.prevent="selectBranch(branch)">
                                <div class="w-100 card m-2"
                                    style="border-radius: 0.25rem; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); display: flex; flex-direction: column; justify-content: space-between;"
                                    :style="selected_branch.id == branch.id ? ' border: 1.5px solid #275D93;' : ' border: 1.5px solid rgba(0,0,0,.125);'">
                                    <div class="d-flex flex-row align-items-center p-2">
                                        <!-- <img id="profile-img" class="profile-img mr-3"
                                            src="//ssl.gstatic.com/accounts/ui/avatar_2x.png" /> -->
                                        <div class="d-flex flex-column px-2">
                                            <small v-if="branch.name" style="font-weight: 600;">
                                                {{ branch.name }}
                                            </small>
                                            <small v-if="branch.brand" style="font-size: 12px;">
                                                {{ branch.brand }}
                                            </small>
                                            <small v-if="branch.brand" style="font-size: 12px;">
                                                {{ branch.phone }}
                                            </small>
                                            <small v-if="branch.address" class="text-muted" style="font-size: 12px;">
                                                {{ branch.address }}
                                            </small>
                                            <small v-if="branch.receiver_name || branch.receiver_phone" class="mt-2"
                                                style="font-weight: 600; font-size: 12px;">
                                                {{ $t('PIC') }} :
                                            </small>
                                            <small v-if="branch.receiver_name" style="font-size: 12px;">
                                                {{ branch.receiver_name }}
                                            </small>
                                            <small v-if="branch.receiver_phone" style="font-size: 12px;">
                                                {{ branch.receiver_phone }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="card-footer d-flex flex-row justify-content-center align-items-center p-2">
                                        <button class="btn btn-block"
                                            :class="selected_branch.id == branch.id ? 'btn-main' : 'btn-secondary'"
                                            @click.stop="selectBranch(branch, true)">
                                            <span v-if="selected_branch.id == branch.id">
                                                <!-- <div v-if="loading" class="dots-loading">
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                </div> -->
                                                <!-- <span v-else> -->
                                                {{ $t('Keep & Continue') }}
                                                <!-- </span> -->
                                            </span>
                                            <span v-else>
                                                {{ $t('Select & Continue') }}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <router-link to="/add-branch"
                                class="d-flex flex-row justify-content-between align-items-center mb-2"
                                style="cursor: pointer; text-decoration: none;">
                                <div class=" w-100 card clickable m-2">
                                    <div class="d-flex flex-row align-items-center justify-content-center p-4">
                                        <font-awesome-icon icon="plus" class="text-main mr-2" style="padding-top: 2px;" />
                                        <small class="text-main font-weight-bold">
                                            {{ $t('Add Destination') }}
                                        </small>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div v-else class="px-4 py-3">
                    <label class="text-main font-weight-bold">{{ $t('Please register a company first!') }}</label>
                </div>
            </div>
        </vue-bottom-sheet>
    </ContainerLayout>
</template>
  
<script>
import ContainerLayout from "../../ContainerLayout.vue";
import { VueBottomSheet } from "@webzlodimir/vue-bottom-sheet";
import "@webzlodimir/vue-bottom-sheet/dist/style.css";
import { ref } from "vue";
import screenSize from "@/plugins/screen-size";
import CompanyService from "@/services/company.service";

export default {
    name: "CompanyDetail",
    components: {
        ContainerLayout,
        VueBottomSheet,
    },
    data() {
        return {
            loading: false,
            branches: [],
            selected_branch: null,
            first_load_branch: false,
            modal_branch_opened: false,
            users: [],
            transactions: [],
        };
    },
    setup() {
        const modalBranch = ref(null);
        const openModalBranch = () => {
            modalBranch.value.open();
        };
        const closeModalBranch = () => {
            modalBranch.value.close();
        };

        const screen = () => {
            return screenSize.size;
        };

        return {
            modalBranch,
            openModalBranch,
            closeModalBranch,
            screen,
        };
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
        currentCompany() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user.company : null;
        },
        currentBranch() {
            return localStorage.getItem('branch') ? JSON.parse(localStorage.getItem('branch')) : null;
        },
    },
    created() {
        if (this.currentUser && this.currentUser.company_id == null) {
            this.$router.push("/profile");
        }

        this.selected_branch = this.currentBranch;
        this.branches = this.currentCompany ? this.currentCompany.branches : [];
        if (this.currentCompany) {
            this.loading = true;
            let loader = this.$loading.show();

            CompanyService.get(this.currentCompany.id)
                .then((response) => {
                    this.loading = false;
                    loader.hide();

                    this.branches = response.data.data.branches;
                    if (this.selected_branch == null) {
                        this.selected_branch = this.branches[0];
                        localStorage.setItem('branch', JSON.stringify(this.selected_branch));
                    }

                    this.users = response.data.data.users;
                    this.transactions = response.data.data.paid_transactions;
                })
                .catch((error) => {
                    this.loading = false;
                    loader.hide();
                    console.log(error);
                });
        }
    },
    methods: {
        openIframe(url, name) {
            let data = {
                url: url,
                name: name,
            }

            this.$router.push({
                name: "File Preview",
                query: {
                    data: this.$encryptString(JSON.stringify(data), 'encryptKey'),
                }
            });
        },

        changeBranch() {
            this.openModalBranch();

            setTimeout(() => {
                if (!this.first_load_branch) {
                    this.first_load_branch = true;

                    let bottomSheetPan = document.getElementsByClassName("bottom-sheet__pan")[0];
                    while (bottomSheetPan.firstChild) {
                        bottomSheetPan.removeChild(bottomSheetPan.firstChild);
                    }
                    bottomSheetPan.classList.add("d-flex", "align-items-center", "h-auto", "pt-2", "pb-0");

                    let closeButtonWrapper = document.createElement("div");
                    closeButtonWrapper.classList.add("d-flex", "w-100", "px-2", "pb-2");
                    closeButtonWrapper.style.borderBottom = "2px solid #e0e0e0";

                    let closeButton = document.createElement("div");
                    closeButton.classList.add(
                        "badge-custom",
                        "badge-outlined",
                        "badge-dark",
                    );
                    // closeButton.style.position = "absolute";
                    closeButton.style.left = "10px";
                    closeButton.style.top = "10px";
                    closeButton.style.cursor = "pointer";
                    closeButton.style.backgroundColor = "transparent";
                    closeButton.style.border = "none";
                    closeButton.style.fontSize = "22px";
                    closeButton.style.fontWeight = "500";
                    closeButton.innerHTML = 'x';

                    let detailText = document.createElement("span");
                    detailText.innerHTML = this.$t("Choose Destination");
                    detailText.style.marginLeft = "10px";
                    detailText.style.fontSize = "16px";
                    detailText.style.fontWeight = "700";

                    // Append the detailText element to closeButton
                    closeButton.appendChild(detailText);
                    closeButton.addEventListener("click", () => {
                        this.closeModalBranch();
                    });

                    closeButtonWrapper.appendChild(closeButton);
                    bottomSheetPan.appendChild(closeButtonWrapper);

                    let bottomSheetCardHeight = document.getElementsByClassName("bottom-sheet__card")[0].offsetHeight;
                    let bottomSheetPanHeight = document.getElementsByClassName("bottom-sheet__pan")[0].offsetHeight;
                    document.getElementById("modal-main-branch").style.height = (bottomSheetCardHeight - bottomSheetPanHeight) + "px";

                    let modalMainHeight = document.getElementById("modal-main-branch").offsetHeight;
                    document.getElementById("modal-body-branch").style.height = modalMainHeight + "px";
                }
            }, 10);
        },

        selectBranch(branch, close = false) {
            // if (!this.loading) {
            if (this.selected_branch.id != branch.id) {
                this.selected_branch = branch;
                localStorage.setItem('branch', JSON.stringify(branch));
            }
            if (close) {
                setTimeout(() => {
                    this.closeModalBranch();
                }, 250);
            }
            // }
        },

        addBranch() {
            this.$router.push("/add-branch");
        },
    }
};
</script>
  
<style scoped>
.skeleton-line {
    width: 75px;
    height: 21px;
    background-color: #e6e6e6;
    border-radius: 5px;
}
</style>